import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { HtmlPageMeta } from '~/components/HtmlPageMeta/HtmlPageMeta'
import { HtmlPageMetaResourceService } from '~/components/HtmlPageMeta/HtmlPageMetaResourceService'
import { Faq } from '~/components/Faq/Faq'
import { FaqPageViewModel } from '~/modules/PresentationAdapters/FaqPageAdapter'
import styles from './MarketFaqPage.module.scss'

export interface MarketFaqPageProps {
  viewModel: FaqPageViewModel
}

export const MarketFaqPage: NextPage<MarketFaqPageProps> = ({ viewModel }) => {
  const { t } = useTranslation('faq')
  const htmlPageMetaUrlProps = (
    new HtmlPageMetaResourceService(t('faq_page_title'), t('faq_page_description'))
  ).getProperties()
  const htmlPageMetaProps = { ...viewModel.htmlPageMetaContextProps, ...htmlPageMetaUrlProps }

  return (
    <>
      <HtmlPageMeta { ...htmlPageMetaProps } />

      <div className={ styles.marketFaqPage }>
        <section className={ styles.marketFaqPage__container }>
          <header className={ styles.marketFaqPage__header }>
            <p className={ styles.marketFaqPage__eyebrow }>
              { t('section_title') }
            </p>
            <h1 className={ styles.marketFaqPage__title }>
              { t('faq_page_title') }
            </h1>
            <p className={ styles.marketFaqPage__subtitle }>
              { t('faq_page_description') }
            </p>
          </header>

          <div className={ styles.marketFaqPage__content }>
            <Faq appearance="museumHome" showTitle={ false } />
          </div>
        </section>
      </div>
    </>
  )
}
